import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from '@mui/material/Stack';

import { Button, TextField } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getURLBase, updateHeightAfterContentUpdate } from '../../../utils/helperFns';
import wyzrTheme from '../../../styles/customTheme';
import axios from 'axios';
export class EditEnvelope extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/envelopeedit";
        this.state = {
            isReady: false,
            gid: this.props.gid,
            env_id: this.props.envelope.env_id,
            selectedDate : new Date(this.props.envelope.target_date), //new Date().setDate(new Date().getDate() + 1),
            selectedGoal : this.props.envelope.target,
            isOn: this.props.envelope.auto_deposit
        }
    }

    postEditEnv = () => {
        let newEnv = {
            "env_id": this.state.env_id,
            "auto_deposit": this.state.isOn,
            "tgt_amt": this.state.selectedGoal,
            "tgt_date": this.state.selectedDate
        }

        console.log("postEditEnv: ", newEnv);
        axios.post(this.url, { gid: this.state.gid, data: newEnv }).then(res => { 
            console.log("Post Response Edit Envelope: ", res.data);
        })
        this.props.toggleHandler();
    }

    handleChange = (input) => {
        var c;
        if (input.target.checked)
            c = true;
        else c = false;
        this.setState({
            isOn: c
        })
    }

    inputHandler = (value) => {
        if(value <= 0) this.setState({goalError:"Goal value should be strictly greater than 0"});
        else this.setState({goalError:null,selectedGoal:value});
    }

    render() {
        return (
            <Card className="popup" id="child_EditEnvelope">
                <Grid maxWidth={420} mx={"auto"}>
                    <Box className="popupClose">
                        <IconButton aria-label="Close" onClick={() => this.props.toggleHandler(true)}>
                            <ArrowBackIcon />
                        </IconButton>
                    </Box>
                    <CardContent textAlign="center" display="flex" flexDirection="column" justifyContent="center">
                        <Stack justifyContent="center">
                            <Box className="popupHeader">
                                <Stack alignItems="center" direction="column">
                                    {
                                        this.props?.envelope?.icon ? <img src={this.props?.envelope?.icon} height={36} width={36} mx={"auto"} alt="" /> : null
                                    }
                                    <Typography variant="h5" mt={2} align="center" gutterBottom sx={{ textTransform: "capitalize" }}>
                                        {this.props.envelope.category}
                                    </Typography> 
                                </Stack>
                            </Box>

                            <Box className="popupBody" pt={{ xs: 10, sm: 0 }}>

                                <Grid container spacing={2} mt={2}>
                                    <Grid item xs={6}>
                                        <Box position="relative">
                                            <Typography variant="h4" sx={{ color: 'action.active', mr: 1, my: 0.5, position: "absolute", left: 0, top: 16 }}>
                                                £
                                            </Typography>
                                            <TextField label="save"
                                            onChange={(event) => this.inputHandler(event.target.value)}
                                            InputProps={{
                                                inputProps: {
                                                    min: 0
                                                }
                                            }} className="inputBig inputIcon" defaultValue={this.state.selectedGoal} type="number" variant="standard" />
                                            {
                                                this.state.goalError? 
                                                    <Typography variant='caption' color={wyzrTheme.palette.error.light}>{ this.state.goalError}</Typography> : null
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="by target date"
                                                minDate={new Date().setDate(new Date().getDate())}
                                                value={this.state.selectedDate}
                                                onChange={(newValue) => {
                                                    this.setState({ selectedDate: newValue })   
                                                }}
                                                renderInput={(params) => <TextField defaultValue={new Date().setDate(new Date().getDate() + 1)} className="inputBig" variant="standard" {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>


                                <Typography variant="subtitle1" color="text.secondary" align="center" mt={3}>
                                    Suggested saving for this goal based on your past spending
                                </Typography>
                            </Box>
                        </Stack>

                        <Stack justifyContent="center" mt={10}>
                            <FormControlLabel sx={{ margin: "auto" }} onChange={this.handleChange} control={<Switch checked={this.state.isOn}/>} label={this.state.isOn ? "On" : "Off"} />
                            <Typography variant="body1" align="center" color="text.secondary" mt={2} mb={4}>
                                Switch ON to automatically put a part of your money into this envelope, whenever you save.
                            </Typography>
                        <Button variant="outlined" size="small" mt={4} sx={{ maxWidth: "50%", margin: "auto" }} onClick={this.postEditEnv}>
                            Save
                        </Button>
                        </Stack>
                    </CardContent>
                </Grid>
                {updateHeightAfterContentUpdate(this.props.parent, "child_EditEnvelope", "parent_SavingEnvelopes")}
            </Card>
        );
    }
}

export default EditEnvelope
